import createDataContext from "./createDataContext";

const views = [
  { id: 0, title: "campañas" },
  { id: 1, title: "suscripciones" },
  { id: 2, title: "me interesan" },
  { id: 3, title: "ajustes" }
];

const viewsReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case "set_view":
      return { ...state, currentView: payload };
    default:
      return state;
  }
};

const setView = dispatch => async view => {
  const choice = views.filter(e => e.id === view);

  if (!choice) {
    throw new Error("Invalid view choice");
  }

  dispatch({ type: "set_view", payload: choice[0].id });
};

export const { Provider, Context } = createDataContext(
  viewsReducer,
  {
    setView
  },
  { currentView: 0 }
);
